import React from "react";
import HeaderComponent from "../Registration/Components/HeaderComponent";
import SmspackbuyServiceForm from "./smspackbuyServiceForm";
const SmspackbuyService = () => {
  return (
    <div className="customerinformation">
      <HeaderComponent />
      <div className="container content">
        <div className="row">
          <div className=" col-lg-5"></div>
          <div className="customerform_right col-lg-7">
            <SmspackbuyServiceForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmspackbuyService;
